/** Utility functions for new task state management, separated from React hook logic. */
// @ts-check
import { Timestamp } from '@/lib/firebase';

/**
 * @param {any} taskPayload
 * @param {Task[]} allTasks
 * @param {AppUser | null} user
 * @param {(payload: any, tasks: Task[]) => any} augmentNewTaskWithDefaults
 * @returns {any}
 */
export const createNewTaskData = (
  taskPayload,
  allTasks,
  user,
  augmentNewTaskWithDefaults,
) => {
  if (!user?.uid) {
    console.error('No user ID provided when trying to add task.');
    return null;
  }

  const augmented = augmentNewTaskWithDefaults(taskPayload, allTasks);

  return {
    ...augmented,
    completed: false,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  };
};

/**
 * @param {{
 *   taskData: any,
 *   allTasks: Task[],
 *   user: AppUser,
 *   augmentNewTaskWithDefaults: (payload: any, tasks: Task[]) => any,
 *   position: number,
 *   _cancel: () => void,
 *   onAddTask: (task: any, pos: number, uid: string) => Promise<string>,
 *   onTaskAdded?: (id: string) => void
 * }} params
 */
export const executeSaveNewTask = async ({
  taskData,
  allTasks,
  user,
  augmentNewTaskWithDefaults,
  position,
  _cancel,
  onAddTask,
  onTaskAdded,
}) => {
  const { title, ...rest } = taskData;
  if (!title?.trim()) return;

  const validTask = createNewTaskData(
    { title: title.trim(), ...rest },
    allTasks,
    user,
    augmentNewTaskWithDefaults,
  );

  if (!validTask) return;

  const currentPosition = position;

  try {
    const addedTaskId = await onAddTask(validTask, currentPosition, user.uid);
    if (onTaskAdded && addedTaskId) {
      onTaskAdded(addedTaskId);
    }
  } catch (error) {
    console.error('Failed to add task via executeSaveNewTask:', error);
  }
};
